/**
 * What a practice is billed, as the backend serialises it (`revenue_netting.charge_wire`):
 * `{price: {cents, currency}, cycle, source}`, or null when it is billed nothing. Served on the
 * Tenants row (`GET /tenants` items) and on the practice page (`GET /tenants/{id}/360`), and
 * read through this one check by both, so the two cannot disagree on what is printable.
 */
export const BILLING_CYCLES = ["monthly", "annual"];

/**
 * The block when it is the wire shape, else null. The payload is checked before use (a proxy
 * may answer an HTML page with 200): anything malformed yields null, so a screen shows no price
 * rather than "NaN" or a guessed cycle. A caller that must tell "billed nothing" (`null` on
 * the wire) from "unreadable" compares the raw value to null itself.
 */
export function validBilling(billing) {
  if (!billing || typeof billing !== "object") return null;
  const { price, cycle } = billing;
  if (!price || typeof price !== "object") return null;
  if (!Number.isInteger(price.cents)) return null;
  if (typeof price.currency !== "string" || !price.currency) return null;
  if (!BILLING_CYCLES.includes(cycle)) return null;
  return billing;
}
